export default function AppFooter() {
  return (
    <footer className="w-full bg-purple-50 border-t border-purple-100 h-16 flex items-center justify-center">
      <div className="container mx-auto px-4 text-center text-sm text-purple-900">
        &copy; {new Date().getFullYear()} NClood. All rights reserved.
      </div>
    </footer>
  );
}